module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_9005.5070e56e.png";